import { PlatformBusinessesConnectionComponent } from './platform-businesses-connection/platform-businesses-connection.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PlatformBusinessesRoutingModule } from './platform-businesses-routing.module'
import { TranslateModule } from '@ngx-translate/core'
import { CoreModule } from '../../core.module';
import { CustomTranslateModule } from '@flowaccount/landing'

import { PlatformBusinessesBannerComponent } from './platform-businesses-banner/platform-businesses-banner.component'
import { PlatformBusinessesComponent } from './platform-businesses.component'
import { PlatformBusinessesBusinessAdministrationComponent } from './platform-businesses-business-administration/platform-businesses-business-administration.component'
import { PlatformBusinessesConnectComponent } from './platform-businesses-connect/platform-businesses-connect.component'
import { PlatformBusinessesETaxInvoiceComponent } from './platform-businesses-e-tax-invoice/platform-businesses-e-tax-invoice.component'
import { ETaxInvoiceIntroComponent } from './platform-businesses-e-tax-invoice/e-tax-invoice-intro/e-tax-invoice-intro.component'
import { ETaxInvoiceScoreboardComponent } from './platform-businesses-e-tax-invoice/e-tax-invoice-scoreboard/e-tax-invoice-scoreboard.component'
import { ETaxInvoiceSendAndScanComponent } from './platform-businesses-e-tax-invoice/e-tax-invoice-send-and-scan/e-tax-invoice-send-and-scan.component'
import { ETaxInvoiceCtaComponent } from './platform-businesses-e-tax-invoice/e-tax-invoice-cta/e-tax-invoice-cta.component'

@NgModule({
  declarations: [
    PlatformBusinessesComponent,
    PlatformBusinessesBannerComponent,
    PlatformBusinessesConnectionComponent,
    PlatformBusinessesBusinessAdministrationComponent,
    PlatformBusinessesConnectComponent,

    PlatformBusinessesETaxInvoiceComponent,
    ETaxInvoiceIntroComponent,
    ETaxInvoiceScoreboardComponent,
    ETaxInvoiceSendAndScanComponent,
    ETaxInvoiceCtaComponent,
  ],
  imports: [
    CommonModule,
    PlatformBusinessesRoutingModule,
    TranslateModule,
    CoreModule.forRoot(),
    CustomTranslateModule.forChild({ path: 'platform-businesses' }),
  ],
})
export class PlatformBusinessesModule {}
